import s from './membership.Style';
import { styled } from 'styled-components';
import React, { useEffect, useState, useMemo, useRef } from 'react';
import { req } from '../../../@api/request';

interface PrimiumProps {
  plans: any[];
  month: number;
}

interface IFormData {
  P_INI_PAYMENT: string;
  P_MID: string;
  P_OID: string;
  P_AMT: number;
  P_GOODS: string;
  P_UNAME: string;
  P_NEXT_URL: string;
  P_RESERVED: string;
  url: string;
}

const Premium = ({ plans, month }: PrimiumProps) => {
  const plan = plans[0];
  const [formData, setFormData] = useState<IFormData>();
  const formRef = useRef<HTMLFormElement>(null);
  const server = new URL(
    process.env.REACT_APP_HOST_API || 'http://localhost:3333/',
  ).origin;

  const handlePayment = async () => {
    if (!plan.plan_id) {
      alert('결제할 상품을 선택해주세요.');
      return;
    }

    try {
      const res = await req.get(`payment/${plan.plan_id}`);

      setFormData({
        P_INI_PAYMENT: 'CARD',
        P_MID: res.data.data.mid,
        P_OID: res.data.data.oid,
        P_AMT: res.data.data.price,
        P_GOODS: res.data.data.goodname,
        P_UNAME: res.data.data.userName,
        P_NEXT_URL: `${server}/payment/auth/phone?front=${window.location.origin}`,
        P_RESERVED: 'centerCd=Y',
        url: 'https://mobile.inicis.com/smart/payment/',
      });
    } catch (error: any) {
      console.log(error.response.data.message);
    }
  };

  useEffect(() => {
    if (formData && formRef.current) {
      naver_script();
      formRef.current.submit();
    }
  }, [formData]);

  const naver_script = () => {
    if (window.wcs) {
      if (!window.wcs_add as any) window.wcs_add = {};
      window.wcs_add['wa'] = 's_2489d344048e';
      var _conv: any = {};
      _conv.type = 'begin_checkout'; //(필수)
      _conv.items = [
        {
          id: plan.plan_id,
          name: plan.name,
          payAmount: plan.plan_prc,
        },
      ];
      window.wcs.trans(_conv);
    }
  };

  return (
    <s.Container>
      <s.Div>
        <div>
          <s.Title>Premium</s.Title>
          <s.Comment>
            감으로 경매 하지 마세요
            <br />돈 되는 경매를 알려주는 경매 고수들을 위한 서비스
          </s.Comment>
        </div>
        <s.Discount>
          <s.EarlyBird>얼리버드 특전 -50%</s.EarlyBird>
          <s.NormalPrice>
            <s style={{ fontSize: '16px', color: '#616161' }}>2,990,000원</s>
          </s.NormalPrice>
        </s.Discount>
        <s.Row>
          <span style={{ fontWeight: '700', fontSize: '32px' }}>
            {Math.round(plan?.plan_prc).toLocaleString('ko-KR')}원
          </span>
          <span
            style={{
              fontWeight: '500',
              fontSize: '16px',
              color: 'rgba(55, 56, 60, 0.61)',
            }}
          >
            / 1년
          </span>
        </s.Row>
        <s.StartButton
          onClick={handlePayment}
          disabled={plan?.is_discount === 'Y'}
        >
          {plan?.is_discount === 'Y'
            ? '전국 얼리버드 특전(곧 오픈)'
            : '시작하기'}
        </s.StartButton>
      </s.Div>
      <div style={{ width: '100%' }}>
        <s.BenefitList>
          <s.Row style={{ gap: '0px', fontSize: '16px' }}>
            <span style={{ color: '#008AFF' }}>Premium</span>
            <span>의 모든 기능 +</span>
          </s.Row>
          <s.Benefit>
            <img
              src="/assets/images/check/gray_check_20.svg"
              style={{
                width: '24px',
                height: '24px',
              }}
            />
            <span>퀀트 경매 물건정보 공개</span>
          </s.Benefit>
          <s.Benefit>
            <img
              src="/assets/images/check/gray_check_20.svg"
              style={{
                width: '24px',
                height: '24px',
              }}
            />
            <span>퀀트 상세 정보 열람 120건</span>
          </s.Benefit>
          <s.Benefit>
            <img
              src="/assets/images/check/gray_check_20.svg"
              style={{
                width: '24px',
                height: '24px',
              }}
            />
            <span>VIP 투자 보고서 120건 제공</span>
          </s.Benefit>
          <s.Benefit>
            <img
              src="/assets/images/check/gray_check_20.svg"
              style={{
                width: '24px',
                height: '24px',
              }}
            />
            <span>읍/면/동 낙찰통계 제공</span>
          </s.Benefit>
          <s.Benefit>
            <img
              src="/assets/images/check/gray_check_20.svg"
              style={{
                width: '24px',
                height: '24px',
              }}
            />
            <span>하이라이트 경매 기사 출고 3일 전 확인</span>
          </s.Benefit>
        </s.BenefitList>
      </div>
      {formData && (
        <div>
          <form
            method="POST"
            acceptCharset="euc-kr"
            action={formData.url}
            ref={formRef}
            style={{ display: 'none' }}
          >
            {Object.entries(formData).map(([key, value]) => {
              return (
                <input
                  key={key}
                  type="text"
                  name={key}
                  value={value}
                  readOnly
                />
              );
            })}
          </form>
        </div>
      )}
    </s.Container>
  );
};

export default Premium;
